import wx from 'weixin-js-sdk';
export const isMiniApp = async () => {
	//var ua = navigator.userAgent.toLowerCase();
	return new Promise(resolve => {
		// if (ua.match(/MicroMessenger/i) === "micromessenger") {
		//     // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
		// } else {
		//     console.log('不在微信里');
		//     resolve(0);
		// }
		if (wx.miniProgram) {
			wx.miniProgram.getEnv(res => {
				if (res.miniprogram) {
					console.log('在小程序里');
					resolve(1);
				} else {
					console.log('不在小程序里');
					resolve(2);
				}
			});
		} else {
			console.log('浏览器');
			resolve(0);
		}
	});
};
